import {DeleteOutlined} from '@ant-design/icons';
import {Button, Form, Input} from 'antd';
import {useForm} from 'antd/es/form/Form';
import {FormListFieldData} from 'antd/es/form/FormList';
import React, {FC, useEffect, useState} from 'react';

import {EComparisonType} from 'components/form/hooks/use-form-watcher/use-form-watcher-constants';
import {CustomSelect} from 'components/form/inputs/custom-select';

import {BINARY_VALUES} from '../../model/project-investment-info-item-modal.constants';
import {lengthValidationRule, numberLengthValidationRule, numberWithDotRule, requiredInputRule} from '../../utils';

interface IInvestorsItemProps {
    field: FormListFieldData;
    onRemove: (index: number) => void;
}

export const InvestorsItem: FC<IInvestorsItemProps> = ({field, onRemove}: IInvestorsItemProps) => {
    const [form] = useForm();
    const [isForeignInvestor, setIsForeignInvestor] = useState<boolean>(() => {
        const value = form.getFieldValue([field.name, 'isForeignInvestor']);
        return value === BINARY_VALUES.YES;
    });

    useEffect(() => {
        const initialValue = form.getFieldValue([field.name, 'isForeignInvestor']);
        setIsForeignInvestor(initialValue === BINARY_VALUES.YES);
    }, [field.name, form]);
    return (
        <div className="project-item-block">
            <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                onClick={() => onRemove(field.name)}
                className="delete-button"
            />
            <div className="form-flex-row">
                <Form.Item
                    {...field}
                    name={[field.name, 'investorName']}
                    label="Наименование инвестора полное"
                    rules={[requiredInputRule()]}
                >
                    <Input placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    {...field}
                    name={[field.name, 'investorShortName']}
                    label='Наименование инвестора краткое'
                >
                    <Input placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
            </div>

            <div className="form-flex-row">
                <Form.Item
                    {...field}
                    name={[field.name, 'isForeignInvestor']}
                    label='Признак "Иностранный инвестор"'
                    rules={[requiredInputRule()]}
                >
                    <CustomSelect
                        onChange={(value: string) => {setIsForeignInvestor(value === '1')}}
                        settings={{
                            placeholder: 'Выберите вариант ответа',
                            url: 'valueLists/FLEX_VALUE?sublistCode=yes_no_investment_project',
                            valuePath: 'lookupCode',
                            labelPath: 'description',
                        }}
                    />
                </Form.Item>

                {isForeignInvestor ? (
                    <Form.Item
                        {...field}
                        name={[field.name, 'investorForeignRegNumber']}
                        label="Регистрационный номер в стране регистрации"
                        rules={[requiredInputRule()]}
                    >
                        <Input placeholder="Введите значение" autoComplete="off" />
                    </Form.Item>
                ) : (
                    <Form.Item
                        {...field}
                        name={[field.name, 'investorInn']}
                        label="ИНН инвестора"
                        rules={[
                            requiredInputRule(),
                            lengthValidationRule({comparisonOperator: EComparisonType.GREATER, value: 10}),
                            lengthValidationRule({comparisonOperator: EComparisonType.LESS, value: 12}),
                        ]}
                    >
                        <Input placeholder="Введите значение" autoComplete="off" />
                    </Form.Item>
                )}
            </div>
            <div className="form-flex-row">
                <Form.Item
                    {...field}
                    name={[field.name, 'participationRate']}
                    label="Доля участия в инвестиционном проекте (%)"
                    rules={[
                        requiredInputRule(),
                        numberWithDotRule({valueBefore: 3, valueAfter: 2}),
                    ]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    {...field}
                    name={[field.name, 'codeOksm']}
                    label="Код страны по ОКСМ"
                    rules={[
                        requiredInputRule(),
                        numberLengthValidationRule({comparisonOperator: EComparisonType.LESS, value: 3}),
                    ]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    {...field}
                    name={[field.name, 'investorDescription']}
                    label="Дополнительная информация об участии инвестора"
                >
                    <Input placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
            </div>
        </div>
    );
}

